module.exports = __webpack_public_path__ + "media/images/patterns/footer-desktop-nl-8ee28c5f53493c799b0f2f4f14cd08ad.svg";